import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { RealEconomyProduct } from '../../real-economy-macro-category';

export const mobileRealEconomyColumns: Column<RealEconomyProduct>[] =
  [
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
      key: 'productName',
      type: 'string',
    },
    {
        headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValueShort,
        key: 'counterValue',
        type: 'amount',
      },
  ];


export const realEconomyDetailTable: Column<RealEconomyProduct>[] =[
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
    key: 'newContractCode',
    type: 'string',
  },
  {
        headerLabel: walletFinancialPositionsMessages.tableHeaderCommitment,
        key: 'obligation',
        type: 'amount',
      },
  {
      headerLabel: walletFinancialPositionsMessages.tableHeaderVersato,
      key: 'versato',
      type: 'amount',
  },
  {
        headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValue,
        key: 'counterValue',
        type: 'amount',
  },


]
